import React from "react";
import { Box, Snackbar, Alert } from "@mui/material";
import { AutoAwesomeOutlined } from "@mui/icons-material";
import PageHeader from "../../common/PageHeader";
import MarketingJourneys from "./MarketingJourneys";

export default function MarketingAutomations({ lang }) {
  const [snack, setSnack] = React.useState({
    open: false,
    msg: "",
    severity: "success",
  });

  const showSnack = (msg, severity = "success") =>
    setSnack({ open: true, msg, severity });

  return (
    <Box>
      <PageHeader
        title={lang?.marketingAutomations || "Automations"}
        subtitle="Drip journeys: enroll on signup, send Day 0 / Day N automatically (welcome + monetize seeds)"
        icon={AutoAwesomeOutlined}
      />
      <MarketingJourneys showSnack={showSnack} />
      <Snackbar
        open={snack.open}
        autoHideDuration={4000}
        onClose={() => setSnack((s) => ({ ...s, open: false }))}
      >
        <Alert
          severity={snack.severity}
          onClose={() => setSnack((s) => ({ ...s, open: false }))}
        >
          {snack.msg}
        </Alert>
      </Snackbar>
    </Box>
  );
}
